import { useMemo, useState, useEffect } from "react";
import ThemeSwitcher from "../components/ThemeSwitcher";
import { getDashboard } from "../store/slices/auth";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UploadRoster from "./UploadRoster";

export const bodyClass =
  "bg-slate-950 text-slate-100 min-h-screen flex flex-col font-sans selection:bg-blue-600 selection:text-white";

export default function StationMarkup({
  stations = [],
  totalStations = 0,
  statistics = {},
  loading = false,
  error = null,
  search = "",
  setSearch,
  status = "ALL",
  setStatus,

  showModal = false,
  editingStation = null,
  form = {},
  formError = "",
  saving = false,
  detailsLoading = false,
  shoOfficers = [],
  shoOfficersLoading = false,

  subdivisions = [],
  circles = [],
  subdivisionsLoading = false,
  circlesLoading = false,

  onAddStation,
  onEditStation,
  onCloseModal,
  onFormChange,
  onSubdivisionChange,
  onSubmit,
}) {
  const [viewMode, setViewMode] = useState("grid");


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    user,
    dashboard,
    dashboardLoading,
    dashboardError
  } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getDashboard());
  }, [dispatch]);

  const [uploadOpen, setUploadOpen] = useState(false);
  const handleRosterUpload = async ({
    type,
    csvText,
    headers,
    rows,
    replaceExisting,
    fileName,
  }) => {

    return {
      success: true,
      message: `${rows.length} records processed successfully.`,
    };
  };

  const handleLogout = () => {
    const confirmed = window.confirm(
      "Are you sure you want to logout?"
    );

    if (!confirmed) return;

    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    localStorage.removeItem("admin");

    sessionStorage.clear();

    if (window.adminSocket) {
      window.adminSocket.disconnect();
      window.adminSocket = null;
    }

    window.location.replace("/login");
  };


  const getOfficerName = (officer) => {
    if (!officer) return "Not Assigned";
    if (typeof officer === "string") return "Assigned";

    return (
      officer.displayName ||
      officer.username ||
      officer.officerId ||
      "Assigned"
    );
  };

  const getCircleName = (circle) => {
    if (!circle) return "--";
    if (typeof circle === "string") return circle;

    return circle.name || circle.circleId || "--";
  };

  const getSubdivisionName = (subdivision) => {
    if (!subdivision) return "--";
    if (typeof subdivision === "string") return subdivision;

    return subdivision.name || subdivision.subDivisionId || "--";
  };

  const selectedCircles = circles.filter((circle) => {
    const circleSubdivisionId =
      circle.subDivisionId?._id || circle.subDivisionId;

    return (
      String(circleSubdivisionId) === String(form.subDivisionId) &&
      circle.active !== false
    );
  });
  const selectedShoOfficers = shoOfficers.filter((officer) => {
    const designation = String(officer.designation || "").toUpperCase();

    const officerSubdivisionId =
      officer.subDivisionId?._id || officer.subDivisionId;

    const officerCircleId =
      officer.circleId?._id || officer.circleId;

    return (
      ["SHO", "SI"].includes(designation) &&
      officer.active !== false &&
      officer.isDeleted !== true &&
      (!officerSubdivisionId ||
        String(officerSubdivisionId) === String(form.subDivisionId)) &&
      (!officerCircleId ||
        String(officerCircleId) === String(form.circleId))
    );
  });
  return (
    <>
      {/* HEADER */}
      <header className="bg-slate-900 border-b border-slate-800 px-4 py-2 flex items-center justify-between shrink-0 shadow-md h-16 relative z-30">
        {/* 1. OFFICIAL IDENTITY & BRANDING */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-tr from-blue-700 via-indigo-600 to-blue-500 flex items-center justify-center text-white shadow-lg shadow-blue-900/50 text-xl font-black shrink-0 border border-blue-400/30">
            🇮🇳
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h1 className="text-sm font-black tracking-tight text-white flex items-center gap-2 uppercase">
                Nellore Police

              </h1>
            </div>

          </div>
        </div>
        {/* 2. ICONS-WISE PORTAL NAVIGATION BAR (Proper Website Style) */}
        <nav className="hidden lg:flex items-center bg-slate-950 p-1 rounded-xl border border-slate-800 text-xs font-semibold shadow-inner">
          <a href="/admin" className="px-3 py-1.5 text-slate-300 hover:text-white hover:bg-slate-900 rounded-lg transition flex items-center gap-1.5">
            <span>
              🗺️
            </span>
            <span>
              Live Map
            </span>
          </a>
          <a href="/emergency-sos" className="px-3 py-1.5 text-slate-300 hover:text-white hover:bg-slate-900 rounded-lg transition flex items-center gap-1.5">
            <span>
              🚨
            </span>
            <span>
              Incident Grid
            </span>
          </a>


        </nav>
        {/* 3. ACTIONS, TOOLS DROPDOWN LIST, THEME & USER PROFILE */}
        <div className="flex items-center gap-2">
          {/* Register Officer Primary Quick Action */}

          {/* Upload Primary Quick Action */}
          <button onClick={() => setUploadOpen(true)} className="px-3 py-1.5 bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-bold rounded-lg shadow flex items-center gap-1.5 transition">
            <span>
              📤
            </span>
            {' '}
            <span className="hidden sm:inline">
              Upload
            </span>
            {' '}Roster
          </button>
          {/* Operations & Tools Dropdown (Proper List-Wise View) */}
          <div className="relative inline-block text-left" id="header-tools-dropdown-container">


          </div>

          <ThemeSwitcher className="mr-0.5" labelClass="hidden 2xl:inline" />
          <div className="h-6 w-px bg-slate-800 mx-0.5"></div>
          {/* Authenticated Commander Profile & Logout */}
          <div className="flex items-center gap-2 pl-1">
            <div id="header-commander-insignia" className="w-8 h-8 rounded-lg flex items-center justify-center text-xs font-black shadow border border-yellow-400/40 shrink-0" style={{ background: "#172554", color: "#fef08a" }}>
              🦁
            </div>
            <div className="hidden sm:block text-right">
              <div
                id="header-commander-name"
                className="text-xs font-black text-white leading-tight truncate max-w-[130px]"
              >
                {user?.displayName || user?.name || user?.username || "Admin"}
              </div>

              <div
                id="header-commander-scope"
                className="text-[10px] text-amber-300 font-bold leading-tight truncate max-w-[160px]"
              >
                👑 {user?.designation || user?.role || "Administrator"}
              </div>
            </div>
            <button
              type="button"
              onClick={handleLogout}
              title="Logout"
              className="w-8 h-8 rounded-lg bg-slate-800 hover:bg-red-900/40 text-slate-300 hover:text-red-300 border border-slate-700 flex items-center justify-center text-sm transition cursor-pointer"
            >
              🚪
            </button>
          </div>
        </div>
      </header>

      {/* TOP KPI METRIC STRIP (CLICK ANY CARD TO OPEN IN SEPARATE GRID VIEW) */}
      <div className="bg-slate-900/90 border-b border-slate-800/80 px-4 py-2 shrink-0 grid grid-cols-10 gap-2 text-xs">

        {/* Total Sub Divisions */}
        <div
          onClick={() => navigate("/sub-divisions")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-purple-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-purple-400 uppercase font-bold tracking-wider">
              Sub Divisions
            </div>
            <div className="text-base font-black text-purple-300">
              {dashboardLoading ? "..." : dashboard?.totalSubDivisions ?? 0}
            </div>
          </div>
          <span className="text-xl text-purple-400 opacity-50">🏢</span>
        </div>

        {/* Total Circles */}
        <div
          onClick={() => navigate("/circles")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-sky-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-sky-400 uppercase font-bold tracking-wider">
              Total Circles
            </div>
            <div className="text-base font-black text-sky-300">
              {dashboardLoading ? "..." : dashboard?.totalCircles ?? 0}
            </div>
          </div>
          <span className="text-xl text-sky-400 opacity-50">⭕</span>
        </div>

        {/* Total Police Stations */}
        <div
          onClick={() => navigate("/stations")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-teal-400 transition flex items-center justify-between"
        >
          <div>
            <div className="text-[10px] text-teal-400 uppercase font-bold tracking-wider">
              Police Stations
            </div>
            <div className="text-base font-black text-teal-300">
              {dashboardLoading ? "..." : dashboard?.totalStations ?? 0}
            </div>
          </div>
          <span className="text-xl text-teal-400 opacity-50">🚔</span>
        </div>
        <div onClick={() => navigate("/booths")}
          className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-blue-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-slate-400 uppercase font-bold tracking-wider">
              Total Booths
            </div>
            <div id="stat-total-booths" className="text-base font-black text-white">
              {dashboardLoading ? "..." : dashboard?.totalPollingStations ?? 0}
            </div>
          </div>
          <span className="text-xl opacity-40">
            🗳️
          </span>
        </div>
        <div onClick={() => navigate("/officers")} className="cursor-pointer bg-slate-800/60 hover:bg-slate-800 rounded-lg p-2 border border-slate-700/60 hover:border-indigo-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-indigo-400 uppercase font-bold tracking-wider">
              Total Men
            </div>
            <div id="stat-total-staff" className="text-base font-black text-indigo-300">
              {dashboardLoading ? "..." : dashboard?.totalOfficers ?? 0}
            </div>
          </div>
          <span className="text-xl text-indigo-400 opacity-50">
            👮
          </span>
        </div>
        <div onClick={() => navigate("/booths")} className="cursor-pointer bg-rose-950/40 hover:bg-rose-900/40 rounded-lg p-2 border border-rose-600/40 hover:border-rose-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-rose-400 uppercase font-bold tracking-wider">
              Hyper Sensitive
            </div>
            <div id="stat-hyper-sensitive" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.hyperSensitiveBooths ?? 0}
            </div>
          </div>
          <span className="text-xl text-rose-400">
            🔥
          </span>
        </div>
        <div onClick={() => navigate("/booths")} className="cursor-pointer bg-amber-950/30 hover:bg-amber-900/40 rounded-lg p-2 border border-amber-600/40 hover:border-amber-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-amber-400 uppercase font-bold tracking-wider">
              Sensitive
            </div>
            <div id="stat-hyper-sensitive" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.hyperSensitiveBooths ?? 0}
            </div>
          </div>
          <span className="text-xl text-amber-400">
            ⚠️
          </span>
        </div>

        <div onClick={() => navigate("/officers")} title="View Verified On-Site Personnel in Grid View" className="cursor-pointer bg-emerald-950/20 hover:bg-emerald-900/30 rounded-lg p-2 border border-emerald-600/30 hover:border-emerald-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-emerald-400 uppercase font-bold tracking-wider">
              On-Site (≤75m)
            </div>
            <div id="stat-onsite" className="text-base font-black text-emerald-400">
              {dashboardLoading ? "..." : dashboard?.atPollingStation ?? 0}
            </div>
          </div>
          <span className="text-xl text-emerald-500 opacity-60">
            ✓
          </span>
        </div>
        <div id="card-kpi-absent" onClick={() => navigate("/officers")} className="cursor-pointer bg-rose-950/30 hover:bg-rose-900/40 rounded-lg p-2 border border-rose-500/50 hover:border-rose-400 transition flex items-center justify-between">
          <div>
            <div className="text-[10px] text-rose-400 uppercase font-bold tracking-wider">
              Not Attended
            </div>
            <div id="stat-non-attended" className="text-base font-black text-rose-400">
              {dashboardLoading ? "..." : dashboard?.absentAttendance ?? 0}
            </div>
          </div>
          <span className="text-xl text-rose-500">
            ✕
          </span>
        </div>
        <div id="card-kpi-sos" onClick={() => navigate("/emergency-sos")} title="Click to View Active Emergency SOS Distress Incidents Directly" className="cursor-pointer bg-red-950/30 hover:bg-red-900/50 rounded-lg p-2 border border-red-500/50 hover:border-red-400 transition flex items-center justify-between animate-sos-strobe">
          <div>
            <div className="text-[10px] text-red-400 uppercase font-bold tracking-wider">
              Emergency SOS
            </div>
            <div id="stat-sos" className="text-base font-black text-red-500">
              {dashboardLoading ? "..." : dashboard?.activeSOS ?? 0}
            </div>
          </div>
          <span className="text-xl text-red-500">
            🚨
          </span>
        </div>
      </div >

      {/* PAGE TITLE */}
      <section className="px-5 py-5 bg-slate-900/50">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div>
              <div className="text-[10px] uppercase tracking-widest text-blue-400 font-bold mb-1">
                District Administration / Police Station Management
              </div>

              <h2 className="text-xl font-black text-white">
                🚔 All Police Stations
              </h2>

              <p className="text-xs text-slate-400 mt-1">
                View and manage all registered police stations.
              </p>
            </div>

            <button
              type="button"
              onClick={onAddStation}
              className="inline-flex items-center gap-2 rounded-xl bg-blue-600 px-5 py-3 text-sm font-semibold text-white shadow-lg transition hover:bg-blue-700"
            >
              <i className="fa-solid fa-plus"></i>
              Add Police Station
            </button>
          </div>
        </div>
      </section>

      {/* STATISTICS */}
      <section className="px-5 py-4 border-slate-800">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-3 gap-3">
          <div className="bg-slate-900 border border-slate-800 rounded-xl p-3">
            <p className="text-[10px] uppercase text-slate-400 font-bold">
              Total Police Stations
            </p>
            <h3 className="text-xl font-black text-white mt-1">
              {statistics.total || 0}
            </h3>
          </div>

          <div className="bg-emerald-950/30 border border-emerald-700/40 rounded-xl p-3">
            <p className="text-[10px] uppercase text-emerald-400 font-bold">
              Active Stations
            </p>
            <h3 className="text-xl font-black text-emerald-400 mt-1">
              {statistics.active || 0}
            </h3>
          </div>

          <div className="bg-rose-950/30 border border-rose-700/40 rounded-xl p-3">
            <p className="text-[10px] uppercase text-rose-400 font-bold">
              Inactive Stations
            </p>
            <h3 className="text-xl font-black text-rose-400 mt-1">
              {statistics.inactive || 0}
            </h3>
          </div>
        </div>
      </section>

      {/* FILTERS */}
      <section className="px-5 py-4  border-slate-800 bg-slate-950">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row gap-3">
          <div className="relative flex-1">
            <span className="absolute left-3 top-2.5 text-slate-500">
              🔍
            </span>

            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search station name, ID, circle or phone..."
              className="w-full bg-slate-900 border border-slate-700 rounded-xl pl-9 pr-3 py-2 text-xs text-white outline-none focus:border-blue-500"
            />
          </div>

          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="bg-slate-900 border border-slate-700 rounded-xl px-3 py-2 text-xs text-white outline-none"
          >
            <option value="ALL">All Statuses</option>
            <option value="ACTIVE">Active</option>
            <option value="INACTIVE">Inactive</option>
          </select>

          <button
            type="button"
            onClick={() => {
              setSearch("");
              setStatus("ALL");
            }}
            className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-xl text-xs font-bold text-slate-300"
          >
            Reset Filters
          </button>
          <div className="flex items-center gap-1 bg-slate-900 border border-slate-700 rounded-xl p-1">
            <button
              type="button"
              onClick={() => setViewMode("grid")}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition ${viewMode === "grid"
                ? "bg-blue-600 text-white"
                : "text-slate-400 hover:text-white"
                }`}
            >
              <i className="fa-solid fa-grip"></i>
              Grid
            </button>

            <button
              type="button"
              onClick={() => setViewMode("list")}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg text-xs font-bold transition ${viewMode === "list"
                ? "bg-blue-600 text-white"
                : "text-slate-400 hover:text-white"
                }`}
            >
              <i className="fa-solid fa-list"></i>
              List
            </button>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-3 text-[10px] text-slate-500">
          Showing{" "}
          <span className="text-white font-bold">
            {stations.length}
          </span>{" "}
          of {totalStations} police stations
        </div>
      </section>

      {/* STATION LIST */}
      <main className="flex-1 p-5 bg-slate-950">
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <div className="text-center py-20 text-slate-400 text-sm">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-3" />
              Loading police stations...
            </div>
          ) : error ? (
            <div className="text-center py-16 bg-red-950/20 border border-red-800/40 rounded-2xl">
              <p className="text-red-400 text-sm font-bold">
                Failed to load police stations
              </p>

              <p className="text-xs text-slate-400 mt-2">
                {typeof error === "string"
                  ? error
                  : error?.message || "Something went wrong"}
              </p>
            </div>
          ) : stations.length === 0 ? (
            <div className="text-center py-20 bg-slate-900 border border-slate-800 rounded-2xl">
              <div className="text-4xl mb-3">🔍</div>

              <h3 className="text-sm font-bold text-white">
                No Police Stations Found
              </h3>

              <p className="text-xs text-slate-500 mt-2">
                Try changing your search or filters.
              </p>
            </div>
          ) : (
            <>
              {viewMode === "grid" ? (
                /* GRID VIEW */
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                  {stations.map((station) => (
                    <div
                      key={station._id}
                      className="bg-slate-900 border border-slate-800 rounded-2xl p-4 hover:border-blue-500/60 transition shadow-lg"
                    >
                      <div className="flex items-start justify-between gap-3">
                        <div className="min-w-0">
                          <h3 className="text-sm font-black text-white">
                            {station.name || "Unnamed Police Station"}
                          </h3>

                          <p className="text-[11px] text-blue-400 font-bold mt-1">
                            {station.stationId || "--"}
                          </p>
                        </div>

                        <span
                          className={`text-[9px] px-2 py-1 rounded-lg border font-black ${station.active
                            ? "bg-emerald-950 text-emerald-400 border-emerald-800"
                            : "bg-red-950 text-red-400 border-red-800"
                            }`}
                        >
                          {station.active ? "ACTIVE" : "INACTIVE"}
                        </span>
                      </div>

                      <div className="mt-4 space-y-3 text-xs">
                        <div className="flex justify-between gap-3">
                          <span className="text-slate-500">Station Code</span>
                          <span className="text-slate-200 font-semibold">
                            {station.code || "--"}
                          </span>
                        </div>

                        <div className="flex justify-between gap-3">
                          <span className="text-slate-500">Circle</span>
                          <span className="text-slate-200 text-right">
                            {getCircleName(station.circleId)}
                          </span>
                        </div>

                        <div className="flex justify-between gap-3">
                          <span className="text-slate-500">Sub-Division</span>
                          <span className="text-slate-200 text-right">
                            {getSubdivisionName(station.subDivisionId)}
                          </span>
                        </div>

                        <div className="flex justify-between gap-3">
                          <span className="text-slate-500">Station In-Charge</span>
                          <span className="text-slate-200 text-right">
                            {getOfficerName(station.shoOfficerId)}
                          </span>
                        </div>

                        <div className="flex justify-between gap-3">
                          <span className="text-slate-500">Contact Number</span>
                          <span className="text-slate-200">
                            {station.contactNumber || "--"}
                          </span>
                        </div>


                      </div>

                      <div className="mt-4 pt-3 border-t border-slate-800 flex items-center justify-between">
                        <span
                          className={`text-[10px] font-bold ${station.active ? "text-emerald-400" : "text-rose-400"
                            }`}
                        >
                          {station.active ? "Operational" : "Inactive"}
                        </span>

                        <button
                          type="button"
                          onClick={() => onEditStation(station)}
                          className="inline-flex items-center gap-2 rounded-lg bg-blue-600/15 border border-blue-500/30 px-3 py-2 text-xs font-bold text-blue-400 hover:bg-blue-600 hover:text-white transition"
                        >
                          <i className="fa-solid fa-pen-to-square"></i>
                          Edit
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              )
                : (
                  <>

                    <table className="w-full min-w-[950px] text-left">
                      <thead className="bg-slate-800/80">
                        <tr className="text-[10px] uppercase tracking-wider text-slate-400">
                          <th className="px-4 py-4">Station</th>
                          <th className="px-4 py-4">Station Code</th>
                          <th className="px-4 py-4">Circle</th>
                          <th className="px-4 py-4">Sub-Division</th>
                          <th className="px-4 py-4">In-Charge</th>
                          <th className="px-4 py-4">Contact</th>
                          <th className="px-4 py-4">Status</th>
                          <th className="px-4 py-4 text-right">Action</th>
                        </tr>
                      </thead>

                      <tbody className="divide-y divide-slate-800">
                        {stations.map((station) => (
                          <tr
                            key={station._id}
                            className="text-xs hover:bg-slate-800/40 transition"
                          >
                            <td className="px-4 py-4">
                              <p className="font-bold text-white">
                                {station.name || "--"}
                              </p>
                              <p className="text-[10px] text-blue-400 mt-1">
                                {station.stationId || "--"}
                              </p>
                            </td>

                            <td className="px-4 py-4 text-slate-300">
                              {station.code || "--"}
                            </td>

                            <td className="px-4 py-4 text-slate-300">
                              {getCircleName(station.circleId)}
                            </td>

                            <td className="px-4 py-4 text-slate-300">
                              {getSubdivisionName(station.subDivisionId)}
                            </td>

                            <td className="px-4 py-4 text-slate-300">
                              {getOfficerName(station.shoOfficerId)}
                            </td>

                            <td className="px-4 py-4 text-slate-300">
                              {station.contactNumber || "--"}
                            </td>

                            <td className="px-4 py-4">
                              <span
                                className={`text-[9px] px-2 py-1 rounded-lg border font-bold ${station.active
                                  ? "bg-emerald-950 text-emerald-400 border-emerald-800"
                                  : "bg-red-950 text-red-400 border-red-800"
                                  }`}
                              >
                                {station.active ? "ACTIVE" : "INACTIVE"}
                              </span>
                            </td>

                            <td className="px-4 py-4 text-right">
                              <button
                                type="button"
                                onClick={() => onEditStation(station)}
                                className="inline-flex items-center gap-2 rounded-lg bg-blue-600/15 border border-blue-500/30 px-3 py-2 text-xs font-bold text-blue-400 hover:bg-blue-600 hover:text-white transition"
                              >
                                <i className="fa-solid fa-pen-to-square"></i>
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                )}
            </>
          )}
        </div>
      </main >

      {/* ADD / EDIT MODAL */}
      {
        showModal && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4 overflow-y-auto">
            <div className="w-full max-w-2xl bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl my-auto">
              {/* MODAL HEADER */}
              <div className="flex items-center justify-between px-6 py-4 border-b border-slate-800">
                <div>
                  <h2 className="text-lg font-black text-white">
                    {editingStation
                      ? "Edit Police Station"
                      : "Add Police Station"}
                  </h2>

                  <p className="text-xs text-slate-400 mt-1">
                    Enter police station information and hierarchy details.
                  </p>
                </div>

                <button
                  type="button"
                  onClick={onCloseModal}
                  className="w-9 h-9 rounded-lg bg-slate-800 hover:bg-red-600 text-slate-300 hover:text-white transition"
                >
                  ✕
                </button>
              </div>

              {detailsLoading ? (
                <div className="py-16 text-center text-slate-400 text-sm">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-3" />
                  Loading station details...
                </div>
              ) : (
                <>
                  {/* FORM */}
                  <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[65vh] overflow-y-auto">
                    <div>
                      <label className="block text-xs font-bold text-slate-300 mb-2">
                        Station ID <span className="text-red-400">*</span>
                      </label>

                      <input
                        type="text"
                        value={form.stationId || ""}
                        onChange={(e) =>
                          onFormChange("stationId", e.target.value)
                        }
                        placeholder="Enter station ID"
                        disabled={saving}
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl px-3 py-3 text-sm text-white outline-none focus:border-blue-500 disabled:opacity-50"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-bold text-slate-300 mb-2">
                        Station Code <span className="text-red-400">*</span>
                      </label>

                      <input
                        type="text"
                        value={form.code || ""}
                        onChange={(e) =>
                          onFormChange("code", e.target.value)
                        }
                        placeholder="Enter station code"
                        disabled={saving}
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl px-3 py-3 text-sm text-white outline-none focus:border-blue-500 disabled:opacity-50"
                      />
                    </div>

                    <div className="md:col-span-2">
                      <label className="block text-xs font-bold text-slate-300 mb-2">
                        Police Station Name <span className="text-red-400">*</span>
                      </label>

                      <input
                        type="text"
                        value={form.name || ""}
                        onChange={(e) =>
                          onFormChange("name", e.target.value)
                        }
                        placeholder="Enter police station name"
                        disabled={saving}
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl px-3 py-3 text-sm text-white outline-none focus:border-blue-500 disabled:opacity-50"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-bold text-slate-300 mb-2">
                        Contact Number <span className="text-red-400">*</span>
                      </label>

                      <input
                        type="tel"
                        maxLength={10}
                        value={form.contactNumber || ""}
                        onChange={(e) =>
                          onFormChange(
                            "contactNumber",
                            e.target.value.replace(/\D/g, "")
                          )
                        }
                        placeholder="10-digit contact number"
                        disabled={saving}
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl px-3 py-3 text-sm text-white outline-none focus:border-blue-500 disabled:opacity-50"
                      />
                    </div>

                    <div>
                      <label className="block text-xs font-bold text-slate-300 mb-2">
                        Sub-Division <span className="text-red-400">*</span>
                      </label>

                      <select
                        value={form.subDivisionId || ""}
                        onChange={(e) =>
                          onSubdivisionChange(e.target.value)
                        }
                        disabled={subdivisionsLoading || saving}
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl px-3 py-3 text-sm text-white outline-none focus:border-blue-500 disabled:opacity-50"
                      >
                        <option value="">
                          {subdivisionsLoading
                            ? "Loading Sub-Divisions..."
                            : "Select Sub-Division"}
                        </option>

                        {subdivisions.map((item) => (
                          <option key={item._id} value={item._id}>
                            {item.subDivisionId
                              ? `${item.subDivisionId} - ${item.name}`
                              : item.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-bold text-slate-300 mb-2">
                        Circle <span className="text-red-400">*</span>
                      </label>

                      <select
                        value={form.circleId || ""}
                        onChange={(e) =>
                          onFormChange("circleId", e.target.value)
                        }
                        disabled={
                          !form.subDivisionId ||
                          circlesLoading ||
                          saving
                        }
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl px-3 py-3 text-sm text-white outline-none focus:border-blue-500 disabled:opacity-50"
                      >
                        <option value="">
                          {!form.subDivisionId
                            ? "Select Sub-Division first"
                            : circlesLoading
                              ? "Loading Circles..."
                              : "Select Circle"}
                        </option>

                        {selectedCircles.map((circle) => (
                          <option key={circle._id} value={circle._id}>
                            {circle.circleId
                              ? `${circle.circleId} - ${circle.name}`
                              : circle.name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div>
                      <label className="block text-xs font-bold text-slate-300 mb-2">
                        Station In-Charge (SHO / SI)
                      </label>

                      <select
                        value={
                          typeof form.shoOfficerId === "object"
                            ? form.shoOfficerId?.badgeNo || ""
                            : form.shoOfficerId || ""
                        }
                        onChange={(e) =>
                          onFormChange("shoOfficerId", e.target.value)
                        }
                        disabled={
                          !form.subDivisionId ||
                          !form.circleId ||
                          shoOfficersLoading ||
                          saving
                        }
                        className="w-full bg-slate-950 border border-slate-700 rounded-xl px-3 py-3 text-sm text-white outline-none focus:border-blue-500 disabled:opacity-50"
                      >
                        <option value="">
                          {!form.subDivisionId
                            ? "Select Sub-Division first"
                            : !form.circleId
                              ? "Select Circle first"
                              : shoOfficersLoading
                                ? "Loading SHO / SI officers..."
                                : "Select SHO / SI"}
                        </option>

                        {selectedShoOfficers.map((officer) => (
                          <option key={officer._id} value={officer.badgeNo}>
                            {officer.badgeNo} - {officer.displayName || officer.username}
                            ({officer.designation})
                          </option>
                        ))}
                      </select>
                    </div>


                    {/* ACTIVE STATUS */}
                    <div className="md:col-span-2 bg-slate-950 border border-slate-800 rounded-xl p-4 flex items-center justify-between">
                      <div>
                        <p className="text-sm font-bold text-white">
                          Station Status
                        </p>
                        <p className="text-xs text-slate-500 mt-1">
                          Enable or disable this police station.
                        </p>
                      </div>

                      <button
                        type="button"
                        disabled={saving}
                        onClick={() =>
                          onFormChange("active", !form.active)
                        }
                        className={`relative w-12 h-6 rounded-full transition ${form.active ? "bg-emerald-600" : "bg-slate-700"
                          }`}
                      >
                        <span
                          className={`absolute top-1 w-4 h-4 rounded-full bg-white transition ${form.active ? "left-7" : "left-1"
                            }`}
                        />
                      </button>
                    </div>

                    {formError && (
                      <div className="md:col-span-2 bg-red-950/40 border border-red-800 rounded-xl p-3">
                        <p className="text-xs text-red-400">
                          {typeof formError === "string"
                            ? formError
                            : formError?.message || "Something went wrong"}
                        </p>
                      </div>
                    )}
                  </div>

                  {/* MODAL FOOTER */}
                  <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-800">
                    <button
                      type="button"
                      onClick={onCloseModal}
                      disabled={saving}
                      className="px-5 py-2.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-sm font-bold text-slate-300 disabled:opacity-50"
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      onClick={onSubmit}
                      disabled={saving}
                      className="px-6 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-sm font-bold text-white disabled:opacity-50"
                    >
                      {saving ? (
                        "Saving..."
                      ) : editingStation ? (
                        "Update Police Station"
                      ) : (
                        "Create Police Station"
                      )}
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )
      }
      <UploadRoster
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        defaultTab="OFFICERS"
        tabs={[
          "OFFICERS",
          "SUBDIVISIONS",
          "CIRCLES",
          "STATIONS",
          "BOOTHS",
        ]}
        onUpload={handleRosterUpload}
        onSuccess={() => {
          console.log("Refresh officer list");
        }}
      />
      {/* FOOTER */}
      <footer className="px-5 py-3 border-t border-slate-800 bg-slate-900 text-center">
        <p className="text-[10px] text-slate-500">
          Nellore Police • Police Station Administration
        </p>
      </footer>
    </>
  );
}
